import { Loader } from 'components-legacy';
import { useTranslations } from 'next-intl';
import TComponent from './TComponent';

export default function TBody({
  items,
  keys,
  components,
  Actions,
  children,
  isLoading,
  error,
  selectedItem
}) {
  const t = useTranslations();

  if (!keys) return null;

  if (error) {
    notifyException(error);
    return (
      <tbody>
        <tr>
          <td colSpan={keys.length} className="center-text p-5">
            <p className="color-danger">
              <span className="ticon-warning" /> {t('transactions.unexpected_error')}
            </p>
            {Array.isArray(error?.data) && (
              <ul>
                {error.data.map(({ message }, i) => (
                  <li key={i}>{message}</li>
                ))}
              </ul>
            )}
          </td>
        </tr>
      </tbody>
    );
  }

  if (!items)
    return (
      <tbody>
        <tr>
          <td colSpan={keys.length} className="center-text p-5">
            <Loader />
            <p>{t('transactions.loading')} ...</p>
          </td>
        </tr>
      </tbody>
    );

  return (
    <tbody className="loader_ellipsis__container">
      {isLoading && (
        <tr>
          <td colSpan={keys.length} className="loader_ellipsis__background p-5">
            <Loader />
          </td>
        </tr>
      )}
      {items.map((item, i) => (
        <tr
          key={`tbody-tr-${item.id}`}
          style={{
            ...{ height: '48px' },
            ...(selectedItem == i ? { background: '#E3F3FF' } : {})
          }}
        >
          {keys.map((key) => (
            <TComponent key={key} componentFn={components[key]} attribute={item[key]} item={item} />
          ))}
          {Actions && <Actions {...item} />}
        </tr>
      ))}
      {children}
    </tbody>
  );
}
